import React from "react";
import { type FreefieldInputProps } from "shared/utils/freeFields/models";
import moment from "moment";
import OptionalDateTimePicker from "components/DatePicker/OptionalDateTimePicker";
import { isFreeFieldDateEmpty } from "shared/utils/freeFields/utils";

const FreefieldDateTime = (props: FreefieldInputProps) => {
  const [date, setDate] = React.useState(!isFreeFieldDateEmpty(props.initialValue) ? moment.utc(props.initialValue) : undefined);

  const onDateChange = (date: moment.Moment) => {
    setDate(date);
    props.onChange(date ? date.toISOString() : undefined);
  };

  // Legacy form: cancels the checkbox padding and keeps the row height when unchecked
  return <div className="flex" style={{ minHeight: 32, marginLeft: -8 }}>
    <OptionalDateTimePicker
      validatorKey={`freefield${props.reference}`}
      minDate={moment(serverReference.constants.appointment.minDate)}
      maxDate={moment(serverReference.constants.appointment.maxDate)}
      value={date}
      onChange={onDateChange}
    />
  </div>;
};

export default FreefieldDateTime;